import {Component, OnInit} from '@angular/core';
import {ClientInfoService} from '../ClientInfo/client-info.service';

import {ApplicationService} from './application.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {PatientService} from '../ClientInfo/patient.service';
import {DataExchangeService} from '../../../../surface3d/src/lib/API/Public/data-exchange.service';
import {DrawViewService} from '../Editor/DrawView/draw-view.service';


@Component({
    selector: 'burncase-application',
    templateUrl: './application.component.html',
    styleUrls: ['./application.component.css'],
    animations: [
        trigger('settings', [
            transition(':enter', [
                style({opacity: 0, transform: 'translate(250px, 0)'}),
                animate('300ms', style({opacity: 1, transform: 'translate(0, 0)'}))
            ]),
            transition(':leave', [
                style({opacity: 1}),
                animate('250ms', style({opacity: 0, transform: 'translate(250px, 0)'}))
            ])
        ])
    ]
})
export class ApplicationComponent implements OnInit {

    public isHandset$ = this.clientInfoService.isHandsetObservable;

    constructor(private clientInfoService: ClientInfoService,
                public applicationService: ApplicationService,
                public drawViewService: DrawViewService,
                private patientService: PatientService, private dataExchangeService: DataExchangeService) {
        this.dataExchangeService.patient.id = this.patientService.patientID;
    }

    ngOnInit(): void {
    }

    activateMode(event: boolean) {
        this.applicationService.activateMode(event);
    }

}
